module.exports = __webpack_public_path__ + "assets/modecontain.77ade7c9.svg";